import React from 'react'

function VIP({chancellor}) {
  return (
    <div className='vips'>
      <ul>
        <li>
            <img src={chancellor.img}/>
        </li>
        <li>
            <ul>
                <li>{chancellor.name}</li>
                <li>{chancellor.Role}</li>
            </ul>
        </li>
      </ul>
    </div>
  )
}

export default VIP
